<div [innerHTML]="content | safe: 'html'" [id]="id"></div>
<ng-template #dynamicContainer></ng-template>
